import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchDomainsThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchDomains`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getDomains();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch domains. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
